<template>
    <div class="indexpage" > 
        <headerpage :status="0"></headerpage>
        <div class="box" :style="{height:height+'px'}" style="position: relative;">
            <img :src="common.home_pic | addurl" style="width: 100%;height: 100%;position: absolute;top: 0;" />
            <img src="../../assets/images/qie/10.png" class="box_top_img" />
            <div class="box_bot">
                <div class="box_bot_tt">
                    <div class="box_bot_tt_t" :class="topindex==0?'box_sty':''" @click="topindex=0">查公司</div>
                    <div class="box_bot_tt_t" :class="topindex==1?'box_sty':''" @click="topindex=1">查政策</div>
                </div>
                 
                <div class="box_bot_cet">
                    <input :placeholder="topindex==0?'请输入公司名称':'请输入政策名称'"  v-model="keyword" class="box_bot_cet_left" />
                    <div class="box_bot_cet_right" @click="sou">
                        <i class="el-icon-search" style="margin-right: 5px;"></i>
                        搜索
                    </div>
                </div>
            </div>
        </div>
        <div class="box1 adaptation">
            <a href="/information" class="box1_cent1" target="_blank">
                <div class="box1_cent1_tt">中原国家广告产业园数据大屏</div>
            </a>
            <div class="box1_cent" v-for="(item,index) in cetlist">
                <div class="box1_cent_top">
                    <img :src="item.image" class="box1_cent_top_t" />
                    <div class="box1_cent_top_t1">{{item.name}}</div>
                    <!-- <div class="box1_cent_top_t2">{{item.name1}}</div> -->
                    <div class="box1_cent_top_t3" @click="listchange(item.path,item.listtype)">更多>></div>
                </div>
                <div class="box1_cent_cet" v-for="(eitem,eindex) in item.list" @click="jumpdetail(eitem.id,item.type)">
                    <div class="box1_cent_cet_t"></div>
                    <div class="box1_cent_cet_t1">{{eitem.title}}</div>
                    <div class="box1_cent_cet_t2">{{eitem.new_time}}</div>
                </div>
                <div v-if="item.list.length==0">
                    <Nomore></Nomore>
                </div>
            </div>
        </div>
        <div class="box1 adaptation" style="flex-direction: column;">
            <div class="box1_cent_top">
                <img src="../../assets/images/qie/3.png" class="box1_cent_top_t" />
                <div class="box1_cent_top_t1">优秀企业</div>
                <!-- <div class="box1_cent_top_t2">/ Excellent enterprise</div> -->
                <!-- <div class="box1_cent_top_t3">更多>></div> -->
            </div>
            <!--   class="box2"  -->
            <el-carousel height="150px"  class="box2"  indicator-position="outside" >
                <!--  -->
                <el-carousel-item v-for="item in qylist">
                    <div class="box2_cent">
                        <img class="box2_cet" v-for="eitem in item" :src="eitem.image | addurl" />
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <footers></footers>
    </div>
</template>
<script>
var myChart;
import headerpage from '../../components/header/header.vue';
import footers from "@/components/foot/footer.vue";
let image1 = require('../../assets/images/qie/4.png')
let image2 = require('../../assets/images/qie/8.png')
let image3 = require('../../assets/images/qie/7.png')
import windowchange from '@/util/window'
import Nomore from '../../components/nomore.vue';
import { mapGetters } from 'vuex'
// import { query } from 'express';
export default {
    mixins: [windowchange],
    computed: {
			...mapGetters({
				common: 'user/common', 
			}),
		},
    data() {
        
        return {
            keyword:'',
            topindex: 0,
            // height: 500,
            // height1: 500,
            cetlist: [
                {
                    image: image2,
                    name: "政策资讯",
                    name1: "/  Policy information",
                    list: [],
                    path:'bulletinlist',
                    type:1,
                },
                {
                    image: image1,
                    name: "园区通知",
                    name1: "/  The park notice",
                    list: [],
                    path:'listpage',
                    type:3,
                    listtype:1
                },
                {
                    image: image3,
                    name: "园区要闻",
                    name1: "/  News of the park",
                    list: [],
                    type:4,
                    path:'listpage',
                    listtype:2
                }
            ],
            qylist:[]
        };
    },
    methods: {
        goods_company(){
            var api = this.$api.api.demo.goods_company;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
               
            }, (response) => {
                var list = []
                var num = 0
                for(var i=0;i<response.data.length;i++){
                    // console.log(i)
                    if(i%4==0&&i!==0){
                        num++
                    }if(!list[num]){
                            list[num] = []
                        }
                        list[num] = list[num].concat(response.data[i])
                }
                this.qylist = list
                
            }, (error) => {
                console.log(error);
            });
        },
        informationList(){
            var api = this.$api.api.index.informationList;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                page:1,
                page_size:8,
                type: 4
            }, (response) => {
                this.cetlist[0].list = response.data.data
                
            }, (error) => {
                console.log(error);
            });
        },
        notice_list(type){
            var api = this.$api.api.demo.notice_list;
            this.$https.post({
                api: api,
                type: "formData",
            }, {
                page:1,
                page_size:8,
                type: type
            }, (response) => {
                this.cetlist[type].list = response.data
            }, (error) => {
                console.log(error);
            });
        },
        sou() {
            if (this.topindex == 0) {
                this.$router.push({ path: "enterprise" ,query: { keyword:this.keyword}});
            }else {
                this.$router.push({ path: "policy",query: { keyword:this.keyword}});
            }
        },
        jumpdetail(id,type){
            this.$router.push({ path:'detail',query: { type:type, id: id }});
        },
        listchange(path,type) {
            // let routeUrl = this.$router.resolve({
            //     name: "listpage"
            // });
            // window.open(routeUrl.href, "_blank"); 
            if(type){
                this.$router.push({ path:path,query: {type: type}});
            }else{
                this.$router.push({ path:path});
            }
             
        },
        large() {
            let routeUrl = this.$router.resolve({
                name: "information"
            });
            console.log("routeUrl", routeUrl, window.open);
            window.open(routeUrl.href, "_blank");
        }
    },
    created(){
        this.informationList()
        this.notice_list(1)
        this.notice_list(2)
        this.goods_company()
    },
    components: { Nomore,headerpage,footers}
};
</script>
<style lang="scss">
.indexpage{
     .el-carousel__button {
        width: 10px;
        height: 10px;
        border: none;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.2);
    }
    .el-carousel__indicator--horizontal{
        padding: 0 4px;
        margin-top: 25px;
    }
     .is-active .el-carousel__button {
        background: #0170c1;
         
    }
    .el-carousel__arrow{
        background-color: rgba(0, 0, 0, 0.6) !important;
        font-size: 34px;
        // display: block !important;
        height: 100%;
        width: 40px;
        border-radius: 0;
    }
    .el-carousel__arrow--left{
        left: 0;
    }
    .el-carousel__arrow--right{
        right: 0 !important;
    }
}
</style>
<style scoped lang="scss">
.box {
    background-size: 100% 100%;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_top_img {
    width: 905px;
    /* height: 51px; */
    position: absolute;
    top: 12%;
}

.box_bot {
    display: flex;
    align-items: center;
    position: absolute;
    justify-content: center;
    bottom: 11%;
    width: 100%;
}

.box_bot_tt {
    position: absolute;
    top: -50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* width: 150px; */
}

.box_bot_cet {
    width: 65%;
    height: 50px;
    background-color: #ffffff;
    border-radius: 27px;
    min-width: 900px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box_bot_cet_left {
    flex: 1;
    font-size: 18px;
    padding: 0 20px;
}

.box_bot_cet_right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 103px;
    height: 43px;
    background-color: #0170c1;
    border-radius: 21px;
    font-size: 18px;
    color: #ffffff;
    cursor: pointer;
}

.box_bot_tt_t {
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    width: 86px;
    text-align: center;
}

.box_sty {
    width: 86px;
    height: 33px;
    background-color: #ffffff;
    border-radius: 16px;
    color: #0170c1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_sty::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #ffffff;
    bottom: -5px;
    transform: rotate(45deg);

}

.box1 {
   
    margin: 30px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 0;
}

.box1_cent1 {
    width: 49%;
    height: 361px;
    position: relative;
    background: url('../../assets/images/qie/12.png');
    background-size: 100% 100%;
    margin-bottom: 40px;
    cursor: pointer;
}

.box1_cent1_tt {
    position: absolute;
    left: 10px;
    bottom: 15px;
    font-size: 16px;
    color: #ffffff;
}

.box1_cent {
    width: 49%;
    height: 361px;
    margin-bottom: 40px;
}

.box1_cent_top {
    width: 100%;
    height: 63px;
    background-color: #0170c1;
    border-radius: 31px;
    display: flex;
    align-items: center;
    padding: 0 30px;
    position: relative;
}

.box1_cent_top_t {
    width: 30px;
    height: 30px;
}

.box1_cent_top_t1 {
    font-size: 22px;
    color: #ffffff;
    margin: 0 5px;
}

.box1_cent_top_t2 {
    font-size: 16px;
    color: #ffffff;
    margin-left: 6px;
}

.box1_cent_top_t3 {
    font-size: 16px;
    position: absolute;
    right: 23px;
    color: #ffffff;
    cursor: pointer;
}

.box1_cent_cet {
    display: flex;
    align-items: center;
    margin-top: 13px;
    cursor: pointer;
    padding: 0 10px;
}

.box1_cent_cet_t {
    width: 4px;
    height: 4px;
    background-color: #aaa;
    border-radius: 50%;
}

.box1_cent_cet_t1 {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 10px;
    margin-right: 20px;
    font-size: 16px;

}

.box1_cent_cet_t2 {
    font-size: 15px;
    color: #b1b1b1;

}
.box2{ 
    width: 100%;
    margin: 30px 0;
}
.box2_cent{
    display: flex;
    align-items: center;
    justify-content: space-between; 
    height: 100%;
}
.box2_cet{
    width: 280px;
    height: 100%;
}

 
</style>



// WEBPACK FOOTER //
// index.vue?3cab6b35